export default "__VITE_ASSET__sj0KKfY4__"